import { config } from '../../../shared/config';

// tslint:disable: variable-name
export class MobileAppRequest {
  SourceSystemID: string;
  SourceDeviceID: string;
  PlatformID: number;
  ClubID: number;
  LanguageID: number;
  UniqID: number;

  constructor() {
    this.ClubID = config.defaultClubId,
    this.LanguageID = +config.defaultLcid,
    this.UniqID = Math.floor((Math.random() * 100) + 1);
  }
}
